import {URL_REG_EXP} from '../constants';

export const validateURL = (url: string): boolean => {
  const pattern = new RegExp(URL_REG_EXP, 'i');

  return !!pattern.test(url);
}